import React from 'react'
import createRouter5, { Route, Router } from 'router5'
import { useRoute } from 'react-router5'
import browserPlugin from 'router5-plugin-browser'

export interface IApplicationRouter {
  router: Router,
  getApplicationRoute: () => IApplicationRoute,
  RenderPage: () => JSX.Element,
}

export interface IApplicationRoute extends Route {
  render: () => JSX.Element,
  meta: Record<string, any>,
}

// Default not found route that can be overridden
export const DEFAULT_NOT_FOUND_ROUTE: IApplicationRoute = {
  name: 'notfound',
  path: '/notfound',
  meta: {
    title: 'Page Not Found',
  },
  render: () => <div>Page Not Found</div>,
}

// Configuration options for router creation
export interface RouterConfig {
  notFoundRoute?: IApplicationRoute
  defaultRouteName?: string
  queryParamsMode?: 'loose' | 'strict'
}

// Main function to create and configure the router
export function createRouter(routes: IApplicationRoute[], config?: RouterConfig): IApplicationRouter {
  const {
    notFoundRoute = DEFAULT_NOT_FOUND_ROUTE,
    defaultRouteName = 'notfound',
    queryParamsMode = 'loose',
  } = config || {}

  // Combine application routes with not found route
  const allRoutes = [...routes, notFoundRoute]
  
  // Create and configure the router
  const router = createRouter5(allRoutes, {
    defaultRoute: defaultRouteName,
    queryParamsMode,
  })

  router.usePlugin(browserPlugin())
  
  // Hook to get the current application route
  const getApplicationRoute = (): IApplicationRoute => {
    const { route } = useRoute()
    return allRoutes.find(r => r.name === route?.name) || notFoundRoute
  }

  // Component to render the current route
  const RenderPage = () => {
    const route = getApplicationRoute()
    return route.render()
  }

  return {
    router,
    getApplicationRoute,
    RenderPage,
  }
}

export default createRouter
